// Namespaced because connected_apps.id is client-supplied, so a bare "managed"
// could collide with a real connector id in connector_usage_daily.
export const MANAGED_AI_CONNECTOR_ID = "3b:managed-ai";
export const MANAGED_AI_CONNECTOR_LABEL = "Managed by 3B";
